import React from "react";
import ReactDOM from "react-dom/client";
import { AppProviders } from "./app/AppProviders";
import { AppRoutes } from "./app/router/AppRoutes";
import "./styles.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  document.body.innerHTML =
    '<main class="login-shell" role="alert"><section class="login-card"><h1>SS Core cannot start safely</h1><p class="login-copy">The application root element is missing from index.html.</p></section></main>';
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </React.StrictMode>,
  );
}
